import MainBox from "./components/MainBox";
import SearchElement from "./pages/Search";

function App() {
  return (
    <MainBox>
      <SearchElement />
    </MainBox>
  );
}

export default App;
